import {Controller} from "stimulus"

let delayTimer;
export default class extends Controller {

    connect() {
        console.log("hello from licensing-reports-licensee_history");
    }

    updateReport(e) {
        console.log("report changed")
        clearTimeout(delayTimer);
        delayTimer = setTimeout(function () {
            const year = document.getElementById("year")
            const licenseTypeCategory = document.getElementById("license_type_category_id")
            const jurisdiction = document.getElementById("jurisdiction_id")

            if (year.value != "") {
                document.getElementById("flash-area").innerHTML = ""

                let title = "Licensee History: " + year.value
                if (licenseTypeCategory && licenseTypeCategory.options[licenseTypeCategory.selectedIndex].text != "All") {
                    title += " - " + licenseTypeCategory.options[licenseTypeCategory.selectedIndex].text
                }

                let reportUrl = 'chart?title=' + encodeURIComponent(title) +
                    '&data_source=licensing_reports_licensee_history_index_path&year=' + year.value

                if (licenseTypeCategory && licenseTypeCategory.value) {
                    reportUrl = reportUrl + '&license_type_category_id=' + licenseTypeCategory.value
                }

                if (jurisdiction) {
                    reportUrl = reportUrl + '&jurisdiction_id=' + jurisdiction.value
                }

                window.location.href = reportUrl;
            } else {
                document.getElementById("flash-area").innerHTML = ('<div class="warn">Please select a year.</div>')
                year.classList.add('required-field')
            }

        }, 2500)
    }
}
